// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.drag-drop {
  background: #fff;
  border: 1px solid var(--border-color);
  border-radius: 8px;
}
.document-uploader {
  border: 2px dashed #4282fe;
  background-color: #f4fbff;
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  border-radius: 8px;
  cursor: pointer;

  &.active {
    border-color: #6dc24b;
  }

  .upload-info {
    display: flex;
    align-items: center;
    margin-bottom: 1rem;

    svg {
      font-size: 36px;
      margin-right: 1rem;
    }

    div {
      p {
        margin: 0;
        /*font-size: 16px;*/
      }

      p:first-child {
        font-weight: bold;
      }
    }
  }

  .file-list {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    width: 100%;
    height: 30vh;
    &__container {
      width: 100%;
      height: 100%;
      overflow: auto;
    }
  }

  .file-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.5rem;
    border: 1px solid var(--border-color);
    border-radius: 8px;

    .file-info {
      display: flex;
      flex-direction: column;
      gap: 0.25rem;
      flex: 1 1;

      p {
        margin: 0;
        font-size: 14px;
        color: #333;
      }
    }

    .file-actions {
      cursor: pointer;

      svg {
        font-size: 18px;
        color: #888;
      }

      &:hover {
        svg {
          color: #d44;
        }
      }
    }
  }

  .browse-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem 1rem;
    border: 1px solid var(--border-color);
    border-radius: 8px;
    cursor: pointer;
    background-color: var(--primary-color);
    &:hover {
      background-color: transparent;
    }
  }

  .success-file {
    display: flex;
    align-items: center;
    color: #6dc24b;

    p {
      margin: 0;
      font-size: 14px;
      font-weight: bold;
    }
  }

  input[type="file"] {
    display: none;
  }
}

.profile_img_only_profile {
  @apply w-40 cursor-pointer;
  border: 1px solid var(--border-color);
  border-radius: 8px;
}

.profile_img_only_username {
  @apply border-4 border-gray-100 w-[135px] rounded-full shadow-lg cursor-pointer;
  @apply hover:border-gray-200;
}

.container_image {
  /*width: 150px;
  height: 150px;
  border: 1px solid red;
  margin: 20px;*/
  position: relative;
  /*list-style: none;*/
  width: 100px;
  height: 100px;
  background-color: #888;
}

.container_image .container_image_on {
  position: absolute;
  top: 0px;
  right: 0px;
  left: 0px;
  bottom: 0px;
  display: none;
  background-color: rgba(10, 10, 10, 0.5);
  justify-content: center;
  align-items: center;
}

.container_image:hover .container_image_on {
  /*display: block !important;*/
  display: flex;
  border-radius: 12px;
  border-color: red;
  border-width: 4px;
  border-style: dashed;
}
`, "",{"version":3,"sources":["webpack://./src/components/proto/components/DragnDrop/drag-drop.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;;EAEf;IACE,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;;IAEnB;MACE,eAAe;MACf,kBAAkB;IACpB;;IAEA;MACE;QACE,SAAS;QACT,mBAAmB;MACrB;;MAEA;QACE,iBAAiB;MACnB;IACF;EACF;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,WAAW;IACX,YAAY;IACZ;MACE,WAAW;MACX,YAAY;MACZ,cAAc;IAChB;EACF;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,qCAAqC;IACrC,kBAAkB;;IAElB;MACE,aAAa;MACb,sBAAsB;MACtB,YAAY;MACZ,SAAO;;MAEP;QACE,SAAS;QACT,eAAe;QACf,WAAW;MACb;IACF;;IAEA;MACE,eAAe;;MAEf;QACE,eAAe;QACf,WAAW;MACb;;MAEA;QACE;UACE,WAAW;QACb;MACF;IACF;EACF;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;IACpB,qCAAqC;IACrC,kBAAkB;IAClB,eAAe;IACf,sCAAsC;IACtC;MACE,6BAA6B;IAC/B;EACF;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,cAAc;;IAEd;MACE,SAAS;MACT,eAAe;MACf,iBAAiB;IACnB;EACF;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,0BAA0B;EAC1B,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,+EAA+E;EAC/E,4BAA4B;AAC9B;;AAEA;EACE;;;gBAGc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,SAAS;EACT,WAAW;EACX,aAAa;EACb,uCAAuC;EACvC,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;AACtB","sourcesContent":[".drag-drop {\n  background: #fff;\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n}\n.document-uploader {\n  border: 2px dashed #4282fe;\n  background-color: #f4fbff;\n  padding: 10px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  border-radius: 8px;\n  cursor: pointer;\n\n  &.active {\n    border-color: #6dc24b;\n  }\n\n  .upload-info {\n    display: flex;\n    align-items: center;\n    margin-bottom: 1rem;\n\n    svg {\n      font-size: 36px;\n      margin-right: 1rem;\n    }\n\n    div {\n      p {\n        margin: 0;\n        /*font-size: 16px;*/\n      }\n\n      p:first-child {\n        font-weight: bold;\n      }\n    }\n  }\n\n  .file-list {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n    width: 100%;\n    height: 30vh;\n    &__container {\n      width: 100%;\n      height: 100%;\n      overflow: auto;\n    }\n  }\n\n  .file-item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0.5rem;\n    border: 1px solid var(--border-color);\n    border-radius: 8px;\n\n    .file-info {\n      display: flex;\n      flex-direction: column;\n      gap: 0.25rem;\n      flex: 1;\n\n      p {\n        margin: 0;\n        font-size: 14px;\n        color: #333;\n      }\n    }\n\n    .file-actions {\n      cursor: pointer;\n\n      svg {\n        font-size: 18px;\n        color: #888;\n      }\n\n      &:hover {\n        svg {\n          color: #d44;\n        }\n      }\n    }\n  }\n\n  .browse-btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0.5rem 1rem;\n    border: 1px solid var(--border-color);\n    border-radius: 8px;\n    cursor: pointer;\n    background-color: var(--primary-color);\n    &:hover {\n      background-color: transparent;\n    }\n  }\n\n  .success-file {\n    display: flex;\n    align-items: center;\n    color: #6dc24b;\n\n    p {\n      margin: 0;\n      font-size: 14px;\n      font-weight: bold;\n    }\n  }\n\n  input[type=\"file\"] {\n    display: none;\n  }\n}\n\n.profile_img_only_profile {\n  @apply w-40 cursor-pointer;\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n}\n\n.profile_img_only_username {\n  @apply border-4 border-gray-100 w-[135px] rounded-full shadow-lg cursor-pointer;\n  @apply hover:border-gray-200;\n}\n\n.container_image {\n  /*width: 150px;\n  height: 150px;\n  border: 1px solid red;\n  margin: 20px;*/\n  position: relative;\n  /*list-style: none;*/\n  width: 100px;\n  height: 100px;\n  background-color: #888;\n}\n\n.container_image .container_image_on {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  left: 0px;\n  bottom: 0px;\n  display: none;\n  background-color: rgba(10, 10, 10, 0.5);\n  justify-content: center;\n  align-items: center;\n}\n\n.container_image:hover .container_image_on {\n  /*display: block !important;*/\n  display: flex;\n  border-radius: 12px;\n  border-color: red;\n  border-width: 4px;\n  border-style: dashed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
